import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import WorkshopSettings from '@/components/organisms/workshop-settings'
import { useAppSelector } from '@/redux/hooks'

export const Route = createFileRoute('/_authenticated/workshop-settings')({
  component: WorkshopSettingsRoute,
})

function WorkshopSettingsRoute() {
  const { t } = useTranslation()
  const activeWorkshopId = useAppSelector(state => state.settings.activeWorkshopId)

  return (
    <div>
      <WorkshopSettings
        workshopId={activeWorkshopId}
        title={t('workshopSettingsPage.title')}
        subtitle={undefined}
      />
      <Outlet />
    </div>
  )
}
